import COUNTRIES from './countries'
import filterOptions from './filterOptions'

const {
  checkboxProvidersOptions,
  providers,
  searchCreatorsSortBy,
  searchCreatorsTopicSortBy,
  videosSortBy,
  tagListSortBy,
  genders,
  ages,
  audienceCountries,
  dateRangeSearch,
  uploadDateSearchVideos,
  customUploadDateRangeSearchVideos,
  language,
  countries,
  chart,
  comparePage,
  length,
  likes,
  comments,
  views,
  numberOfVideos,
  subtopicType,
  creatorTier,
  topicCategory,
  subtopicTopic,
  subtopicCategory,
  subtopic,
  topic,
  formatId,
  title,
  subtopicSearchTerm,
  searchTopicType,
  searchSubtopicType,
  followedCreators,
  trendingCreators,
  creatorType,
  dateRangeButtons,
  uploadDateSearchTopics,
  performanceDateRange,
  tagTitle,
  uploadTrendingDates,
  categories,
  isLive,
  isAdvertisement,
  titleAnd,
  titleOr,
  titleNot,
  youtubeAuditComparePage,
} = filterOptions

// Groups
const contentAndAudience = {
  genders,
  ages,
  countries,
  dateRange: dateRangeSearch,
  language,
  creatorTier,
}

const newVideos = {
  sortBy: videosSortBy,
  providers: checkboxProvidersOptions,
  dateRange: dateRangeSearch,
  uploadDate: customUploadDateRangeSearchVideos,
  subtopic,
  topics: topic,
  formatIds: formatId,
  language,
  likes,
  lengthMin: length,
  lengthMax: length,
  comments,
  views,
  title,
  countries,
  topicCategory: topicCategory,
  tagTitle,
  languages: language,
  categories: categories,
  subtopics: subtopic,
  isLive,
  isAdvertisement,
}

const boardVideosUploadDate = {
  ...newVideos,
}

const searchVideosUploadDate = {
  ...newVideos,
  titleAnd,
  titleOr,
  titleNot,
}

const topics = {
  language,
  ages,
  countries,
  genders,
  dateRange: dateRangeSearch,
}

const topicSubtopicTab = {
  subtopicType,
  title,
}

const topicTagsTab = {
  sortBy: tagListSortBy,
}

const audienceFilters = {
  audienceGenders: genders,
  audienceAges: ages,
  audienceCountries,
}

const searchTopicsPage = {
  language,
  topicCategory,
  subtopicTopic,
  subtopicCategory,
  searchTopicType,
  searchSubtopicType,
  dateRange: uploadDateSearchTopics,
}

const jobTopicsTab = {
  language,
  topicCategory,
  subtopicTopic,
  subtopicCategory,
  searchTopicType,
  searchSubtopicType,
  dateRange: uploadDateSearchTopics,
}

const topicPeopleAlsoWatchTab = {
  title, // Não uso isso, só para ter algo aqui
}

const topicPerformance = {
  dateRange: performanceDateRange,
}

const newSubtopic = {
  language,
  subtopicTopic,
  subtopicCategory,
  subtopicType,
  subtopicSearchTerm,
}

const tagPage = {
  providers,
  sortBy: videosSortBy,
  uploadDate: uploadDateSearchVideos,
}

const guestSignup = {
  countries: COUNTRIES.map(v => ({ key: v.ALPHA_2, value: v.ALPHA_2, label: v.NAME, filterName: 'Countries' })),
}

const newCreators = {
  providers: checkboxProvidersOptions,
  sortBy: searchCreatorsSortBy,
  sortByWithVideoLikes: searchCreatorsTopicSortBy,
  dateRange: dateRangeSearch,
  countries,
  creatorType,
  numberOfVideos,
  creatorTier,
  title,
  language,
  topics: topic,
  topicCategory: topicCategory,
  subtopic,
  followedCreators,
  trendingCreators,
  dateRangeOverall: dateRangeButtons,
}

const trendingVideos = {
  sortBy: videosSortBy,
  providers: checkboxProvidersOptions,
  dateRange: dateRangeSearch,
  uploadDate: uploadTrendingDates,
  language,
  title,
  tagTitle,
  lengthMin: length,
  lengthMax: length,
  countries,
  topicCategory: topicCategory,
  languages: language,
  categories: categories,
  subtopics: subtopic,
  isLive,
  isAdvertisement,
}

const filterGroups = {
  audienceFilters,
  chart,
  comparePage,
  contentAndAudience,
  guestSignup,
  searchTopicsPage,
  jobTopicsTab,
  topicPeopleAlsoWatchTab,
  tagPage,
  topicSubtopicTab,
  topicTagsTab,
  topics,
  newSubtopic,
  newVideos,
  newCreators,
  searchVideosUploadDate,
  boardVideosUploadDate,
  topicPerformance,
  trendingVideos,
  youtubeAuditComparePage,
}

export default filterGroups
